// extracted by css-extract-rspack-plugin
export default {"bodyText":"_99637bd4"};